const _ = require('lodash');
const { capitalize } = require('../utils');

const INFO_BY_CONNECTOR_NAME = {
  googleAnalytics: {
    dataSourcePrefix: 'ga',
    dashboardPrefix: 'googleAnalytics',
  },
  googleSpreadSheet: {
    dataSourcePrefix: 'gss',
    dashboardPrefix: 'gss',
  },
  mailchimpAdAccount: {
    dataSourcePrefix: 'mailchimp',
    dashboardPrefix: 'mailchimp',
  },
  googleAnalytics4 : {
    dataSourcePrefix: 'ga4',
    dashboardPrefix: 'googleAnalytics4',
  },
  adverity: {},
};

const BREAKDOWN_TO_KEY = {
  channel: 'channel',
  adAccount: 'adAccountId',
  campaign: 'channelCampaignIds',
  adSet: 'channelAdSetIds',
  ad: 'channelAdId',
  keyword: 'channelKeywordId',
};

function removeEmptyValues(obj) {
  return Object.entries(obj).reduce((acc, [breakdown, value]) => {
    if (value?.key) {
      acc[breakdown] = value;
    }
    return acc;
  }, {});
}

function getBlendDataQueries({ blendedDataSources, queryRequest }) {
  return blendedDataSources
    .map(dataSource => {
        return {
            ...queryRequest,
            mainDataSource: dataSource,
            dataSources: [dataSource],
        };
    })
}

function getAdDataKeyFromBreakdown(breakdown) {
  const key = BREAKDOWN_TO_KEY[breakdown] || breakdown;
  return key;
}

function getConnectorInfo(connectorName) {
  return INFO_BY_CONNECTOR_NAME[connectorName];
}

function getBlendedBreakdownKey({ dataSource, queryBreakdown }) {
  const blendDataByBreakdown = dataSource.settings?.blendDataByBreakdown;
  if (!blendDataByBreakdown) {
    return null;
  }
  const blendedMarketingBreakdowns = Object.keys(blendDataByBreakdown);
  if (!blendedMarketingBreakdowns?.length) {
    return null;
  }
  let joinBreakdown;
  if (blendDataByBreakdown[queryBreakdown]) {
    joinBreakdown = queryBreakdown;
  } else {
    joinBreakdown = blendedMarketingBreakdowns[0];
  }
  const blendData = blendDataByBreakdown[joinBreakdown];
  return blendData.key;
}

module.exports = { getBlendDataQueries, getConnectorInfo, getBlendedBreakdownKey, getAdDataKeyFromBreakdown };
